import React, { Fragment } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles, Link } from '@material-ui/core';
import { Row, Col, Button, Container, Accordion, Card, Header, Body, Form } from 'react-bootstrap';
import Environment from '../../environment/environment';
import _ from 'lodash';
import OrdenaConvidados from '../../widgets/organizador/ordena-convidados';
import MaterialTable from 'material-table';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import ReactSwitch from '../../widgets/_componentes/ReactSwitch';
import VideoPlayerPopup from '../videoPlayer/videoPlayerPopup';

const { Group } = Form;

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minWidth: '1000px'
    },
    tabRoot: {
        padding: '15px',
    },
    botaoFecharWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '20px'
    },
    modalListLine: {
        marginBottom: '2em',
        '&:first-child': {
            paddingTop: '20px'
        }
    },
    modalListLineTitle: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    modalListLineData: {
        fontSize: '14px'
    },
    modalListLineDataLine: {
        marginBottom: '1em'
    },
    modalListLineDataTitle: {
        fontWeight: '600',
        fontSize: '14px',
        color: '#666'
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    tableVideos: {
        marginTop: '15px;'
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
});

class EncerradasGravacoesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessao: props.session,
            displayModalVideoPlayer: false,
            modalVideoUrl: null
        }
        this.handleCloseVideoPlayerModal = this.handleCloseVideoPlayerModal.bind(this);
    }

    render() {
        const { classes, handleCloseFnc } = this.props;
        const { sessao } = this.state;

        const actions = this.geraActions();
        const videoActions = this.geraVideosActions();

        const jsonPartesRender = (data) => {
            if (!data.json_partes || data.json_partes == '[]') return 'Completo';

            const trechos = JSON.parse(data.json_partes);
            let tag = "";
            trechos.forEach( el => {
                tag = tag ? tag+', '+el.inicio+' até '+el.fim : el.inicio+' até '+el.fim;
            });
            return tag;
        }

        const gravacoesTable = () => {
            return (
                <MaterialTable
                    actions={actions}
                    columns={[
                        { title: "Id", field: "id" },
                        { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                        { title: "Fim", field: "fim", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.fim) },
                        { title: "Publicado", field: "publicado", render: (rowData) => {
                            return <ReactSwitch checked={!!rowData.publicada} disabled={true} />;
                        }},
                    ]}
                    data={sessao.gravacoes}
                    localization={{
                        body: {
                            emptyDataSourceMessage: 'Nenhuma sessão encontrada'
                        },
                        header: {
                            actions: 'Ações'
                        }
                    }}
                    options={{
                        actionsColumnIndex: -1,
                        paging: false,
                        draggable: false,
                        search: false
                    }}
                    title={
                        "Gravações"
                    }
                />
            );
        };

        const videosTable = () => {
            return (
                <MaterialTable
                    columns={[
                        { title: "Nome", field: "nome" },
                        { title: "Início", field: "inicio", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.inicio) },
                        { title: "Partes", field: "json_partes", render: rowData => jsonPartesRender(rowData) },
                        { title: "Criada em", field: "created_at", render: rowData => Environment.momentToLocalDateAndTimeString(rowData.created_at) },
                        { title: "Publicado", field: "publicado", render: (rowData) => {
                            return <ReactSwitch checked={!!rowData.publicado} disabled={true} />;
                        }},
                    ]}
                    data={sessao.videos}
                    actions={videoActions}
                    localization={{
                        body: {
                            emptyDataSourceMessage: 'Nenhum video encontrada'
                        },
                        header: {
                            actions: 'Ações'
                        }
                    }}
                    options={{
                        actionsColumnIndex: -1,
                        paging: false,
                        draggable: false,
                        search: false
                    }}
                    title={
                        "Vídeos"
                    }
                />
            );
        };

        return (
            <Paper className={classes.root}>
                <Row>
                    <Col className={classes.headerWrapper}>
                        <Button onClick={handleCloseFnc} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                    </Col>
                </Row>
                {this.defineModalVideoPlayer()}
                <Row>
                    <Col>
                        { sessao.gravacoes.length > 0 ? gravacoesTable() : null }
                    </Col>
                </Row>
                <Row className={classes.tableVideos}>
                    <Col>
                        { sessao.videos.length > 0 ? videosTable() : null }
                    </Col>
                </Row>
            </Paper>
        );
    }

    geraActions() {
        const actions = [];

        actions.push({
            icon: VisibilityOutlinedIcon,
            tooltip: 'Assistir Gravação',
            onClick: (event, rowData) => {
                window.open(rowData.url_ver);
            }
        });

        return actions;
    }

    geraVideosActions() {
        const actions = [];
        actions.push({
            icon: VisibilityOutlinedIcon,
            tooltip: 'Assistir Video',
            onClick: (event, rowData) => {
                this.setState({
                    displayModalVideoPlayer: true,
                    modalVideoUrl: rowData.url_video
                });
            }
        });
        return actions;
    }

    defineModalVideoPlayer() {
        const { displayModalVideoPlayer, modalVideoUrl } = this.state;
        const { classes } = this.props;

        if (!modalVideoUrl) return null;

        return (
            <Modal open={displayModalVideoPlayer} onClose={this.handleCloseVideoPlayerModal}>
                <div className={classes.modalWrapper}>
                    <VideoPlayerPopup videoUrl={modalVideoUrl} handleCloseFnc={this.handleCloseVideoPlayerModal} />
                </div>
            </Modal>
        );
    }

    handleCloseVideoPlayerModal() {
        this.setState({
            displayModalVideoPlayer: false,
            modalVideoUrl: null
        });
    }

}

export default (withStyles(styles)(EncerradasGravacoesModal));